import { defineStore } from "pinia";

import store from "./index";
interface UseStore {
  token: string | null;
  config: { [key: string]: string } | null;
  userInfo: any;
}
export interface RouteRow {
  name: string;
  path: string;
  meta: { [key: string]: string };
  children?: RouteRow[];
  component: any;
  routeName?: string;
  redirect?: () => {};
}
export const useStore = defineStore("user", {
  state: (): UseStore => {
    return {
      token: null,
      config: null,
      userInfo: null
    };
  },
  getters: {},
  actions: {
    setToken(token: string) {
      this.token = token;
    },
    setUser(data: any) {
      this.userInfo = data;
    }
  }
});

export function useUserStore() {
  return useStore(store);
}
